export default "__VITE_ASSET__BzOh0JSp__"